import { render } from "./AppInlineMenu.vue?vue&type=template&id=500985c6&scoped=true"
import script from "./AppInlineMenu.vue?vue&type=script&lang=js"
export * from "./AppInlineMenu.vue?vue&type=script&lang=js"

import "./AppInlineMenu.vue?vue&type=style&index=0&id=500985c6&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-500985c6"]])

export default __exports__